import { directive as vClickOutside } from "vue-clickaway";
import {VueConstructor} from 'vue/types';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue: VueConstructor) {
    Vue.directive("click-outside", vClickOutside);
    Vue.directive('only-int', {
      inserted(el, binding) {
        el.oninput = (event) => {
          // @ts-ignore
          const formattedValue = parseInt(event.target.value, 10);
          // @ts-ignore
          el.value = isNaN(formattedValue) ? '' : formattedValue;
        };
        if (parseInt(binding.value)) {
          el.onkeypress = (event) => {
            // @ts-ignore
            if(el.value.length>=binding.value) return false; else el.value=parseInt(el.value)||''
          };
        }
      }
    })
    Vue.directive('only-float', {
      inserted(el, binding) {
        el.oninput = (event) => {
          // @ts-ignore
          el.value = (/^[0-9\.\-]+$/.test(event.target.value)) ? event.target.value : '';
        };
        if (parseFloat(binding.value)) {
          el.onkeypress = (event) => {
            // @ts-ignore
            if(el.value.length>=binding.value) return false; else el.value=parseFloat(el.value)||''
          };
        }
      }
    })
  }
};

export default GlobalDirectives;
